import * as z from 'zod';

const jobSchema = z.object({
  jobId: z.number(),
  jobName: z.string(),
  level: z.number()
});

const jobsSchema = z.array(jobSchema);

export const jobExperienceSchema = z.object({
  management: jobsSchema,
  consultingAndPlanning: jobsSchema,
  development: jobsSchema,
  infrastructure: jobsSchema,
  data: jobsSchema,
  operationAndPlatform: jobsSchema,
  customerSupport: jobsSchema,
  salesAndPublicRelations: jobsSchema,
  other: jobsSchema
});

export type Job = z.infer<typeof jobSchema>;
export type JobExperience = z.infer<typeof jobExperienceSchema>;
